import React from 'react';
import { motion } from 'framer-motion';
import { experiences } from '../data/experiences';

const ExperienceContent = () => (
  <div className="experience-content">
    <h2>{'// work_history.log'}</h2>
    <div className="timeline">
      {experiences.map((exp, i) => (
        <motion.div
          key={i}
          className="timeline-item"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: i * 0.1 }}
        >
          <div className="timeline-marker" />
          <div className="timeline-content">
            <div className="exp-header">
              <h3>{exp.company}</h3>
              <span className="exp-period">{exp.period}</span>
            </div>
            <p className="exp-role">
              {exp.role} <span className="exp-location">• {exp.location}</span>
            </p>
            <p className="exp-desc">{exp.description}</p>
            <div className="exp-tech">
              {exp.tech.map(t => <span key={t}>{t}</span>)}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  </div>
);

export default ExperienceContent;
